<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingMask :visible="showLoadingMask" :text="loadingText" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="套餐名称" prop="packageName">
        <a-input v-model="form.packageName" placeholder="请输入套餐名称" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="短信数量" prop="smsCount">
        <a-input
          v-model="form.smsCount"
          placeholder="请输入短信数量(条)"
          :maxLength="20"
          oninput="value=value.replace(/[^\d]/g,'')"
          @blur="calculateUnitPrice"
        />
      </a-form-model-item>
      <a-form-model-item label="套餐价格" prop="price">
        <a-input
          v-model="form.price"
          placeholder="请输入(元)"
          :maxLength="20"
          oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')"
          @blur="calculateUnitPrice"
        />
      </a-form-model-item>
      <a-form-model-item label="单价" prop="unitPrice">
        <a-input
          v-model="form.unitPrice"
          placeholder="请输入单价(元/条)"
          :maxLength="20"
          oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')"
          @blur="formatUnitPrice"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="有效期(天)" prop="validDays">
        <a-input
          v-model="form.validDays"
          placeholder="请输入有效期(天)，0表示永久有效"
          :maxLength="20"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item> -->
      <a-form-model-item label="套餐描述" prop="description">
        <a-textarea v-model="form.description" placeholder="请输入套餐描述" :maxLength="200" :rows="3" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入排序号" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/sms/package'
import LoadingMask from '@/components/LoadingMask.vue'
export default {
  name: 'CreateForm',
  components: {
    LoadingMask,
  },
  data() {
    return {
      submitLoading: false,
      showLoadingMask: false,
      loadingText: '',
      data: [],
      formTitle: '',
      form: {
        id: undefined,
        packageName: undefined,
        smsCount: undefined,
        price: undefined,
        unitPrice: undefined,
        validDays: 365,
        description: undefined,
        remark: undefined,
        sort: 99,
      },
      open: false,
      rules: {
        packageName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        smsCount: [{ required: true, message: '请输入短信数量', trigger: 'blur' }],
        price: [{ required: true, message: '请输入套餐价格', trigger: 'blur' }],
        unitPrice: [{ required: false, message: '请输入单价(元/条)', trigger: 'blur' }],
        validDays: [{ required: true, message: '请输入有效期(天)', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  methods: {
    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },
    onCloseConfirm(okFn) {
      this.$confirm({
        title: '关闭后已填数据将被清空，是否继续？',
        onOk: okFn,
        onCancel: () => {},
      })
    },
    reset() {
      this.form = {
        id: undefined,
        packageName: undefined,
        smsCount: undefined,
        price: undefined,
        unitPrice: undefined,
        validDays: 365,
        description: undefined,
        remark: undefined,
        sort: 99,
      }
    },
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '新增短信套餐'
    },
    handleUpdate(row) {
      this.reset()
      getObj(row.id).then((response) => {
        if (response.data.status === 1) {
          this.$message.warning('启用状态的套餐不允许修改')
          return
        }
        this.form = response.data
        this.open = true
        this.formTitle = '修改短信套餐'
      })
    },
    // 计算单价 (元/条) - 只在套餐价格或短信数量修改时触发
    calculateUnitPrice() {
      if (this.form.smsCount && this.form.price) {
        const smsCount = parseFloat(this.form.smsCount)
        const price = parseFloat(this.form.price)
        if (smsCount > 0 && price > 0) {
          this.form.unitPrice = (price / smsCount).toFixed(4)
        }
      }
    },
    // 格式化单价，确保只保留四位小数
    formatUnitPrice() {
      if (this.form.unitPrice) {
        const num = parseFloat(this.form.unitPrice)
        if (!isNaN(num)) {
          this.form.unitPrice = num.toFixed(4)
        }
      }
    },
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.setLoadingMask('正在保存数据...')
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .catch(() => {
                this.$message.error('修改失败')
              })
              .finally(() => {
                this.submitLoading = false
                this.hideLoadingMask()
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .catch(() => {
                this.$message.error('新增失败')
              })
              .finally(() => {
                this.submitLoading = false
                this.hideLoadingMask()
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.$message.warning(messages.join('；'))
          return false
        }
      })
    },
    // LoadingMask控制方法
    setLoadingMask(text) {
      this.showLoadingMask = true
      this.loadingText = text
    },
    hideLoadingMask() {
      this.showLoadingMask = false
      this.loadingText = ''
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 0 !important;
}
</style>
